import { useEffect } from 'react';
import { bridge, isApp } from 'shared/src/utils';
import { useInstanceId } from 'shared/src/hooks';

export const useReportTTFD = () => {
  const instanceId = useInstanceId();

  useEffect(() => {
    if (!instanceId) {
      return;
    }
    if (isApp()) {
      bridge.reportTTFD({ instanceId });
    }
  }, [instanceId]);
};
